import { render, staticRenderFns } from "./UserPosMove.vue?vue&type=template&id=fa372dd4&scoped=true"
import script from "./UserPosMove.vue?vue&type=script&lang=js"
export * from "./UserPosMove.vue?vue&type=script&lang=js"
import style0 from "./UserPosMove.vue?vue&type=style&index=0&id=fa372dd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa372dd4",
  null
  
)

export default component.exports